import React from 'react';

import { defineMessages, useIntl } from 'react-intl-next';

import { cssMap } from '@atlaskit/css';
import Heading from '@atlaskit/heading';
import AiGenerativeAudioBriefingIcon from '@atlaskit/icon-lab/core/ai-generative-audio-briefing';
import { Flex, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import { PlaylistEmptyIllustration } from '../assets/PlaylistEmptyIllustration';

const messages = defineMessages({
	emptyPlaylistHeading: {
		id: 'ai-audio.playlist.empty.heading',
		defaultMessage: 'Queue up some work',
		description: 'Heading shown when the playlist is empty',
	},
	emptyPlaylistDescription: {
		id: 'ai-audio.playlist.empty.description',
		defaultMessage: 'Tap {audioIcon} on Pages and Live Docs to add to your list',
		description: 'Description shown when the playlist is empty, explaining how to add items',
	},
	audioIconLabel: {
		id: 'ai-audio.playlist.empty.audio-icon-label',
		defaultMessage: 'Audio briefing icon',
		description:
			'Accessibility label for the audio briefing icon in the empty playlist description',
	},
});

const styles = cssMap({
	container: {
		flex: 1,
		alignItems: 'center',
		justifyContent: 'center',
		textAlign: 'center',
		paddingTop: token('space.200'),
		paddingRight: token('space.200'),
		paddingBottom: token('space.200'),
		paddingLeft: token('space.200'),
		flexGrow: 1,
	},
	content: {
		width: '290px',
		textAlign: 'center',
		paddingLeft: token('space.400'),
		paddingRight: token('space.400'),
	},
});

export const PlaylistEmptyView = () => {
	const { formatMessage } = useIntl();

	return (
		<Flex
			xcss={styles.container}
			justifyContent="center"
			alignItems="center"
			rowGap="space.200"
			direction="column"
		>
			<PlaylistEmptyIllustration />
			<Flex xcss={styles.content} alignItems="center" rowGap="space.150" direction="column">
				<Heading size="small" as="h3">
					{formatMessage(messages.emptyPlaylistHeading)}
				</Heading>
				<Text size="medium" color="color.text.subtlest">
					{formatMessage(messages.emptyPlaylistDescription, {
						audioIcon: (
							<AiGenerativeAudioBriefingIcon label={formatMessage(messages.audioIconLabel)} />
						),
					})}
				</Text>
			</Flex>
		</Flex>
	);
};
